import { Injectable, RendererFactory2 } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { finalize, Observable, timeout } from "rxjs";
import { LoaderService } from "./services/loader.service";
import { MsalBroadcastService, MsalInterceptor, MsalService } from "@azure/msal-angular";
import { Location } from "@angular/common";
import { MSALInterceptorConfigFactory } from './msal-config'; // Import the configuration

@Injectable()
export class AppInterceptor extends MsalInterceptor implements HttpInterceptor {
  apiCount: number = 0;

  constructor(
    MsalBroadcastSvc: MsalBroadcastService,
    MsalSvc: MsalService,
    location: Location,
    rendererFactory: RendererFactory2,
    private loaderService: LoaderService
  ) {
    super(MSALInterceptorConfigFactory(), MsalSvc, location, MsalBroadcastSvc, rendererFactory.createRenderer(null, null));
  }
  override intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.toggle_loader(true);
    return super.intercept(req, next).pipe(
      finalize(() => {
        this.toggle_loader(false);
      })
    );
  }

  /**
   * Toggles the pre-loader animation on specific url
   * @param req HttpRequest
   * @param loader can be used to enable or disable the pre-loader animation
   */
  toggle_loader(loader: boolean) {
    if (loader) {
      this.apiCount = this.apiCount + 1;
      this.loaderService.loader = loader;
    } else {
      this.apiCount = this.apiCount - 1;
      if (this.apiCount <= 0) {
        this.loaderService.loader = loader;
      }
    }
  }
}
